export default {
	"joinOrderPage": {
		"addRoutetips": "选择需要追加的运单"
	},
	"zd": {
		"time": "用时",
		"code": "码",
		"min": "分",
		"hour": "小时",
		"day": "天"
	},
	"orders": {
		"endPickerTime": "实际完成时间",
		"checkedPersonName": "审单人",
		"freightFlag": "是否有运费",
		"viewbill": "查看账单",
		"checkList": "查单",
		"addMark": "补充痕迹",
		"manualAddMark": "手工补充运输痕迹",
		"temperature": "温度",
		"clickToSelectAddress": "请点击图标选择地址",
		"manualEntry": "手工入账",
		"accountsReceivable": "应收账单",
		"rejected": "已拒绝",
		"submitted": "已提交",
		"tips1": "请输入运输订单或者选择查询时间范围",
		"tips2": "是否确定关闭勾选的运输订单",
		"tips3": "请选择需要补充痕迹的车辆",
		"tips4": "请选择时间",
		"tips5": "时间必须大于车辆",
		"tips6": "的开始时间",
		"tips7": "时间必须小于车辆",
		"tips8": "的结束时间",
		"finalCost": "预计/最终费用(元)",
		"latestDeliveryDt": "要求/实际 开始时间",
		"latestReceivedDt": "要求/实际 结束时间",
		"volume": "下单/实际 体积(方)",
		"weight": "下单/实际 重量(千克)",
		"packingQty": "下单/实际 外包装数",
		"taskQty": "任务数量",
		"checkedPersonDt": "审单时间"
	},
	"taskInfo": {
		"actualTemperatureRange": "实际温控范围",
		"actualPackingQty": "实提外包装数",
		"actualGoodsDescription": "实提货品描述",
		"goodsHandoverInfo": "货物交接明细",
		"record": "记录",
		"showOperationRecord": "显示操作记录",
		"showRecordInfo": "显示记录信息",
		"deliverGoodsRelevant": "发货相关",
		"pickRelevant": "签收相关",
		"receiptRelated": "回单相关",
		"RelativeException": "异常相关",
		"askInformation": "要求信息",
		"informationRecord": "记录信息",
		"fileManagement": "文件管理",
		"addFile": "添加附件"
	},
	"tempMonitoring": {
		"noMonitoring": "无监控",
		"screen": "筛选",
		"refresh": "刷新",
		"all": "全部",
		"keyPoint": "重点",
		"grouping": "分组",
		"groupingType": "分组方式",
		"single": "单",
		"stress": "重点",
		"arrived": "已到达",
		"stopMonitoring": "停止监控",
		"monitoring": "监控",
		"distance": "距离",
		"noMonitoringInfo": "无监控信息",
		"thisOvertemp": "本次超温",
		"remainingMileage": "剩余里程",
		"driverTelephone": "司机电话",
		"noticeTips": "是否短信通知司机",
		"messageSentSuccessfully": "消息发送成功",
		"setSuccessfully": "设置成功!"
	},
	"transportContentInfo": {
		"packingDetail": "货物包装明细",
		"logInfo": "操作信息",
		"pickupOperateDt": "提货确认时间",
		"deliveryOperateDt": "送货确认时间",
		"routeCompletionMode": "完成方式",
		"electronicReceiptCheckedDt": "电子确认时间",
		"electronicReceiptCheckedPersonName": "电子确认人"
	},
	"transportInfo": {
		"save": "确认保存",
		"goodsValue": "声明货值",
		"dataCorrect": "数据修正"
	},
	"vehicleList": {
		"workAmount": "作业量",
		"serviceItemsInfo": "服务项信息",
		"orderServiceItemsInfo": "下单服务信息",
		"workServiceItemsInfo": "实际作业服务信息"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/pages/track/track.js